import { render, staticRenderFns } from "./AddExpress.vue?vue&type=template&id=8a87aed0&scoped=true&"
import script from "./AddExpress.vue?vue&type=script&lang=js&"
export * from "./AddExpress.vue?vue&type=script&lang=js&"
import style0 from "./AddExpress.vue?vue&type=style&index=0&id=8a87aed0&lang=scss&scoped=true&"
import style1 from "./AddExpress.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a87aed0",
  null
  
)

export default component.exports